export const BLOG_MD_TEMPLATE = `---
slug: mi-articulo-de-pesca
title: Título visible (H1 de la landing)
type_slug: consejos
excerpt: Resumen corto para la tarjeta del listado (1-2 frases).
meta_title: Título SEO (máx. 60) | AiPeces
meta_description: Descripción SEO (máx. 155).
main_image_url:
---

<h1>Título visible (H1 de la landing)</h1>
<p>Párrafo de entrada. Enlaces internos: <a href="/blog/otro-slug">otra guía</a>.</p>
<h2>Qué debe saber el pescador</h2>
<p>Cuerpo del artículo. Puedes usar tablas, listas y FAQ (&lt;details&gt;).</p>
`;

export const BLOG_AI_SYSTEM_PROMPT = `Eres editor del blog de AiPeces (pesca recreativa en España).

Reglas:
- Un archivo por artículo (.html o .md con frontmatter).
- Clave: slug (URL /blog/{slug}). Si el slug ya existe, el import actualiza y deja En revisión.
- HTML semántico: h1 (uno), h2/h3, p, ul/ol, table, details/summary, a, img.
- Enlaces internos a /blog/..., /atlas/..., /tienda/..., https://www.aipeces.com/...
- Prohibido notas internas: CHAT-1, VB, "pasada 2", AIPECES:DATOS, METADATOS.
- No publiques tú: el import siempre deja el post En revisión.
- type_slug debe existir en el CMS (p. ej. consejos, legal, review).
`;

export function buildBlogAiPrompt(input: {
    slug: string;
    title: string;
    typeSlug?: string | null;
    excerpt?: string;
    metaTitle?: string;
}): string {
    return `${BLOG_AI_SYSTEM_PROMPT}

Artículo actual:
- slug: ${input.slug}
- title: ${input.title}
- type_slug: ${input.typeSlug || '(sin tipología)'}
- excerpt: ${input.excerpt || '(vacío)'}
- meta_title: ${input.metaTitle || '(vacío)'}

Devuelve un único .html con comentario de frontmatter (title, slug, excerpt, meta_title, meta_description) y el cuerpo.
`;
}
